export enum ETourMessageType {
    SCRIPT_READY = 'TOUR_SCRIPT_READY',
    ELEMENT_HIGHLIGHTED = 'TOUR_ELEMENT_HIGHLIGHTED',
    ELEMENT_HIGHLIGHT_CLEARED = 'TOUR_ELEMENT_HIGHLIGHT_CLEARED',
    ELEMENT_SELECTED = 'TOUR_ELEMENT_SELECTED',
    SET_SELECTION_MODE = 'TOUR_SET_SELECTION_MODE',
    URL_CHANGED = 'TOUR_URL_CHANGED',
    PREVIEW_START = 'TOUR_PREVIEW_START',
    PREVIEW_STOP = 'TOUR_PREVIEW_STOP',
    URL_EDIT_PREVIEW = 'TOUR_URL_EDIT_PREVIEW',
}

export enum ETourProject {
    DASHBOARD_APP = 'DASHBOARD_APP'
}

export enum ETourType {
    ON_VISIT = 'ON_VISIT',
    ON_DEMAND = 'ON_DEMAND',
}

export enum ETourTargetType {
    COUNTRY = 'COUNTRY',
    WORKSPACE = 'WORKSPACE',
}

export enum EUrlMatchStrategy {
    PATHNAME = 'PATHNAME',
    EXACT = 'EXACT',
    CONTAINS = 'CONTAINS',
    PATTERN = 'PATTERN',
  }
